module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.pageTitle,
      "visible": _vm.showDialog,
      "show-close": false,
      "top": "10%"
    }
  }, [_c('el-form', {
    ref: "orderForm",
    staticClass: "has-disabledField",
    attrs: {
      "model": _vm.orderForm,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "order_type",
      "error": _vm.error.order_type,
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.orderForm.order_type),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "order_type", $$v)
      },
      expression: "orderForm.order_type"
    }
  }, _vm._l((_vm.orderType), function(item) {
    return _c('el-option', {
      key: item.order_type,
      attrs: {
        "label": item.order_type_str,
        "value": item.order_type
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品",
      "prop": "productId",
      "error": _vm.error.product_id
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.productSearchItem,
      "props": _vm.productSearchProps
    },
    model: {
      value: (_vm.orderForm.productId),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "productId", $$v)
      },
      expression: "orderForm.productId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车牌号",
      "prop": "car_num",
      "error": _vm.error.car_num
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.car_num),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "car_num", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderForm.car_num"
    }
  }, [(_vm.orderForm.order_type !== 1) ? _c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.syn
    },
    slot: "append"
  }, [_vm._v("同步客户信息")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "购车价",
      "prop": "car_price",
      "error": _vm.error.car_price
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.car_price),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "car_price", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderForm.car_price"
    }
  }, [(_vm.orderForm.order_type !== 1) ? _c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.syn
    },
    slot: "append"
  }, [_vm._v("同步客户信息")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车辆按揭状态",
      "prop": "pay_type",
      "error": _vm.error.pay_type
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderForm.pay_type),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "pay_type", $$v)
      },
      expression: "orderForm.pay_type"
    }
  }, _vm._l((_vm.payType), function(o) {
    return _c('el-option', {
      key: o.value,
      attrs: {
        "label": o.name,
        "value": o.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "按揭公司",
      "prop": "mortgage_company",
      "error": _vm.error.mortgage_company
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": 1 == _vm.orderForm.pay_type
    },
    model: {
      value: (_vm.orderForm.mortgage_company),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "mortgage_company", $$v)
      },
      expression: "orderForm.mortgage_company"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请金额",
      "prop": "apply_price",
      "error": _vm.error.apply_price
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.apply_price),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "apply_price", $$v)
      },
      expression: "orderForm.apply_price"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请用途",
      "prop": "apply_purpose",
      "error": _vm.error.apply_purpose
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.apply_purpose),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "apply_purpose", $$v)
      },
      expression: "orderForm.apply_purpose"
    }
  })], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("客户信息")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "name",
      "error": _vm.error.name
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.name),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "name", $$v)
      },
      expression: "orderForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "phone",
      "error": _vm.error.phone
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "phone", $$v)
      },
      expression: "orderForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号码2",
      "prop": "phone2",
      "error": _vm.error.phone2
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.phone2),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "phone2", $$v)
      },
      expression: "orderForm.phone2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "idcard",
      "error": _vm.error.idcard
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.idCardChange
    },
    model: {
      value: (_vm.orderForm.idcard),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "idcard", $$v)
      },
      expression: "orderForm.idcard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月",
      "prop": "birthday",
      "error": _vm.error.birthday
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.orderForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "birthday", $$v)
      },
      expression: "orderForm.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex",
      "error": _vm.error.sex
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "sex", $$v)
      },
      expression: "orderForm.sex"
    }
  }, _vm._l((_vm.userSexItem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "户口所在地",
      "prop": "resident_address",
      "error": _vm.error.resident_address
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.resident_address),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "resident_address", $$v)
      },
      expression: "orderForm.resident_address"
    }
  }, [_c('el-cascader', {
    attrs: {
      "slot": "prepend",
      "options": _vm.cities.list,
      "props": _vm.cities.props
    },
    on: {
      "active-item-change": function (val) {
        return _vm.citiesItemChange(val, true)
      }
    },
    slot: "prepend",
    model: {
      value: (_vm.orderForm.user_cityId),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "user_cityId", $$v)
      },
      expression: "orderForm.user_cityId"
    }
  })], 1)], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("流程信息")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [(_vm.showCheckCar) ? _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "label": "是否验车",
      "prop": "is_check_car"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.is_check_car),
      callback: function($$v) {
        _vm.is_check_car = $$v
      },
      expression: "is_check_car"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "估价方式",
      "prop": "car_load_type",
      "error": _vm.error.car_load_type
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderForm.car_load_type),
      callback: function($$v) {
        _vm.$set(_vm.orderForm, "car_load_type", $$v)
      },
      expression: "orderForm.car_load_type"
    }
  }, _vm._l((_vm.carLoadType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ac55ff0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/part/system/createWin.vue
// module id = 1269
// module chunks = 105